// [ ] remove this file - duplicated in `common` package
export {};
//# sourceMappingURL=DataShape.js.map